import React from 'react';

interface IconProps {
  className?: string;
}

const baseProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export const IconHome: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className}>
    <path d="M3 10.5 12 3l9 7.5" />
    <path d="M5 9.5V20h14V9.5" />
    <path d="M9 20v-6h6v6" />
  </svg>
);

export const IconChart: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className}>
    <path d="M4 20V10" />
    <path d="M10 20V4" />
    <path d="M16 20v-7" />
    <path d="M22 20V8" />
  </svg>
);

export const IconClipboard: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className}>
    <rect x="8" y="2" width="8" height="4" rx="1" />
    <path d="M16 4h1a3 3 0 0 1 3 3v13a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1" />
    <path d="M9 12h6" />
    <path d="M9 16h6" />
  </svg>
);

export const IconMap: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className}>
    <path d="M9 4 3 6v14l6-2 6 2 6-2V4l-6 2-6-2Z" />
    <path d="M9 4v14" />
    <path d="M15 6v14" />
  </svg>
);

export const IconSettings: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 1v2" />
    <path d="M12 21v2" />
    <path d="m4.22 4.22 1.42 1.42" />
    <path d="m18.36 18.36 1.42 1.42" />
    <path d="M1 12h2" />
    <path d="M21 12h2" />
    <path d="m4.22 19.78 1.42-1.42" />
    <path d="m18.36 5.64 1.42-1.42" />
  </svg>
);

export const IconServer: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className}>
    <rect x="2" y="3" width="20" height="6" rx="1" />
    <rect x="2" y="15" width="20" height="6" rx="1" />
    <circle cx="6" cy="6" r="1" fill="currentColor" stroke="none" />
    <circle cx="6" cy="18" r="1" fill="currentColor" stroke="none" />
  </svg>
);

export const IconLogOut: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <path d="M16 17l5-5-5-5" />
    <path d="M21 12H9" />
  </svg>
);

export const IconChevronLeft: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className}>
    <path d="m15 18-6-6 6-6" />
  </svg>
);

export const IconChevronRight: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className}>
    <path d="m9 18 6-6-6-6" />
  </svg>
);
